import { createTranslations } from '@npco/common-utils-translations'

export const editSpendControlsTranslations = createTranslations({
  errorEditing: 'Your preferences could not be saved.',
  successEditing: 'Your preferences have been saved.',
})
